import React from 'react';

const ProyekRobotikRumahan: React.FC = () => {
  return (
    <div className="text-justify py-4">
      <p className="mb-4">
        <b>Survei STEM Education 2024</b> mengungkap bahwa <b>68% pelajar Indonesia</b> tertarik belajar robotik namun terkendala biaya tinggi. Artikel ini menyajikan <b>5 proyek robot sederhana</b> dengan budget di bawah <b>Rp500.000</b> menggunakan komponen lokal tersedia di Tokopedia/Shopee.
      </p>

      <h2 className="text-2xl font-bold mb-4">1. Robot Pengikut Cahaya (Light Follower)</h2>
      <p className="mb-3">
        <b>Komponen utama:</b> LDR sensor (Rp15.000), motor DC (Rp25.000), Arduino Nano (Rp85.000)
      </p>
      <pre className="bg-gray-100 p-3 rounded mb-4">
        {`// Contoh kode dasar
void loop() {
  int leftSensor = analogRead(A0);
  int rightSensor = analogRead(A1);
  if(leftSensor > rightSensor) {
    turnLeft();
  } else {
    turnRight();
  }
}`}
      </pre>
      <p>
        <b>Cara kerja:</b> Robot akan bergerak mengarahkan diri ke sumber cahaya terkuat menggunakan prinsip phototaxis.
      </p>

      <h2 className="text-2xl font-bold mb-4 mt-8">2. Robot Penghindar Halangan (Obstacle Avoidance)</h2>
      <p className="mb-3">
        <b>Komponen utama:</b> Ultrasonic sensor HC-SR04 (Rp30.000), servo motor (Rp45.000)
      </p>
      <p>
        <b>Konsep menarik:</b> Mengimplementasikan algoritma <i>bug algorithm</i> sederhana dimana robot akan:
      </p>
      <ul className="list-disc pl-6 my-2 space-y-1">
        <li>Bergerak lurus hingga halangan terdeteksi</li>
        <li>Berputar 90 derajat ketika jarak {'<'} 15cm</li>
        <li>Meneruskan perjalanan setelah halangan terlewati</li>
      </ul>

      <h2 className="text-2xl font-bold mb-4 mt-8">3. Robot Gambar Otomatis (Drawing Robot)</h2>
      <p className="mb-3">
        <b>Komponen kreatif:</b> Stepper motor 28BYJ-48 (Rp35.000), spidol whiteboard, karet gelang
      </p>
      <p>
        <b>Cara membuat:</b> Dengan prinsip <i>polar coordinate system</i>, robot dapat menggambar bentuk geometris sederhana melalui kode:
      </p>
      <pre className="bg-gray-100 p-3 rounded my-2">
        {`void drawSquare(int size) {
  for(int i=0; i<4; i++) {
    moveForward(size);
    turnRight(90);
  }
}`}
      </pre>

      <h2 className="text-2xl font-bold mb-4 mt-8">4. Robot Kendali Bluetooth</h2>
      <p className="mb-3">
        <b>Komponen kunci:</b> Modul HC-05 (Rp65.000), baterai 18650 (Rp25.000)
      </p>
      <p>
        <b>Pengembangan:</b> Buat aplikasi Android sederhana menggunakan MIT App Inventor dengan tombol:
      </p>
      <div className="grid grid-cols-4 gap-2 mb-3">
        {['⬆️', '⬇️', '⬅️', '➡️'].map((icon, i) => (
          <div key={i} className="border p-2 text-center rounded bg-gray-100">
            {icon}
          </div>
        ))}
      </div>
      <p>
        Setiap tombol mengirim karakter berbeda (U/D/L/R) via Bluetooth ke Arduino.
      </p>

      <h2 className="text-2xl font-bold mb-4 mt-8">5. Robot Pemilah Warna (Color Sorter)</h2>
      <p className="mb-3">
        <b>Sensor utama:</b> TCS3200 color sensor (Rp95.000), conveyor belt sederhana
      </p>
      <p>
        <b>Alur kerja:</b>
      </p>
      <ol className="list-decimal pl-6 space-y-1">
        <li>Deteksi warna objek (merah/hijau/biru)</li>
        <li>Aktifkan servo sesuai warna terdeteksi</li>
        <li>Dorong objek ke wadah terkait</li>
      </ol>
      <pre className="bg-gray-100 p-3 rounded mt-2">
        {`if(redValue > threshold) {
  servoRed.write(90);
  delay(500);
  servoRed.write(0);
}`}
      </pre>

      <h2 className="text-2xl font-bold mb-4 mt-8">Tips Belajar Robotik</h2>
      <div className="bg-green-50 border-l-4 border-green-400 p-4">
        <ul className="list-disc pl-6 space-y-2">
          <li><b>Mulai dari yang sederhana</b> - Kompleksitas bertahap</li>
          <li><b>Gunakan komponen bekas</b> - Motor printer lama bisa dipakai</li>
          <li><b>Komunitas</b> - Ikutan Robotics Indonesia di Discord</li>
          <li><b>3D printing</b> - Badan robot bisa dibuat dengan PCB mockup</li>
        </ul>
      </div>

      <p className="mt-6">
        Proyek-proyek ini telah diuji di <b>Workshop Robotik SMK Jakarta</b> dan terbukti meningkatkan pemahaman siswa tentang:
      </p>
      <div className="flex flex-wrap gap-2 mt-3">
        {['Elektronika Dasar', 'Pemrograman', 'Mekanika', 'Problem Solving'].map((skill, i) => (
          <span key={i} className="bg-blue-100 px-3 py-1 rounded-full text-sm">
            {skill}
          </span>
        ))}
      </div>
    </div>
  );
};

export default ProyekRobotikRumahan;